// nb-NO
export default {
	title: "Gavekortssenter",
	myPoints: "Mine poeng",
	SelectedGifts: "Valgte gaver",
	form: {
		label: {
			title: "Søk",
			points: "Poeng"
		}
	},
	redemption: "Forløsning",
	stock: "Lager",
	id: {
		redeemPoints: "Innløs de nødvendige poengene:",
		btn: "Løs inn nå",
		title: "Kjøp Varsel",
		content: `Kjære medarbeider, takk for at du deltok i arbeidet.\n\nLes følgende vilkår før du løser inn poeng:\n\n[Arbeidspoeng] Etter daglig fullføring av bestillingsdataoptimalisering, kan arbeidere tjene 1 gavepoeng, som kan brukes til delvis innløsning av gavesponsing.\n[Gaveinnløsning] Arbeidere må oppgi relevant informasjon om leveringsadresse, og gaven sendes gratis over hele verden innen 14 dager. Etter at innløsningen er fullført, kan du kontakte kundeservice for å få sporingsnummeret for å spore fremdriften til gaven. Plattformen vil ikke avsløre informasjon til tredjeparter.\nMerk: Når poengene er innløst for gaver, kan de ikke refunderes`
	},
	applyDialog: {
		title: "Mottak av informasjon",
		form: {
			consignee: "Mottaker",
			area: "Område",
			telephone: "Telefon",
			deliveryAddress: "Leveringsadresse"
		},
		btn: "Send til"
	},
	records: {
		title: "Poster",
		status: ["Venter på sending", "Sendt", "Levert", "Avbrutt"]
	}
};
